import Icon from '../components/Icon.vue'

Icon.register({
  landmark: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.6 92.1L267.2 2A32-32 0 0 1 244.8 2L10.4 92.1A16-16 0 0 1 0 107.1V144C0 152.8 7.2 160 16 160H496C504.8 160 512 152.8 512 144V107.1C512 100.4 507.9 94.4 501.6 92.1zM64 192V352H48C39.2 352 32 359.2 32 368V416H480V368C480 359.2 472.8 352 464 352H448V192H384V352H288V192H224V352H128V192H64zM496 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H496C504.8 512 512 504.8 512 496V464C512 455.2 504.8 448 496 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/landmark.js
// module id = z6LE
// module chunks = 144